import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-678a8594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = { class: "pl-3" }
const _hoisted_5 = { class: "w-[130px] text-right text-primary-color pr-3" }
const _hoisted_6 = { class: "g-container hidden sm:block" }
const _hoisted_7 = { class: "g-product-detail g-container mt-[10px]" }
const _hoisted_8 = { class: "product-info flex flex-col sm:flex-row" }
const _hoisted_9 = { class: "product-image w-full h-auto sm:w-[56%] sm:mr-[20px] sm:px-[40px] sm:py-[25px]" }
const _hoisted_10 = { class: "flex-grow sm:basis-1/4 sm:w-[25%] mt-[50px] sm:mt-[25px]" }
const _hoisted_11 = { class: "divide-y-[1px]" }
const _hoisted_12 = { class: "product-detail-header" }
const _hoisted_13 = { class: "text-[22px] sm:text-2xl px-4 text-gary-text-color font-bold" }
const _hoisted_14 = { class: "flex justify-between" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "text-light-gary-text-color text-[13px] sm:text-sm font-light" }
const _hoisted_17 = { class: "product-detail-qty mt-5 pt-5" }
const _hoisted_18 = { class: "product__options flex flex-col gap-4 px-4 text-[15px] sm:text-base text-gary-text-color font-normal" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "basis-[60px] tracking-widest" }
const _hoisted_21 = { class: "flex items-center flex-grow pl-8" }
const _hoisted_22 = ["onUpdate:modelValue"]
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "option select flex items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "basis-[60px] tracking-widest" }, "數量", -1))
const _hoisted_26 = { class: "flex-grow pl-8" }
const _hoisted_27 = { class: "w-[90px]" }
const _hoisted_28 = {
  key: 0,
  class: "package mt-5 pt-5"
}
const _hoisted_29 = { class: "px-4 flex basis-full items-center" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ml-[9px] text-gary-text-color font-bold text-[0.937rem]" }, " 禮品包裝 ", -1))
const _hoisted_31 = { class: "mt-4 w-full" }
const _hoisted_32 = { class: "g-collapse" }
const _hoisted_33 = { class: "flex flex-nowrap overflow-auto gap-[3px]" }
const _hoisted_34 = { class: "text-base mt-[6px] text-gary-text-color relative cursor-pointer" }
const _hoisted_35 = { class: "truncate" }
const _hoisted_36 = { class: "text-sm" }
const _hoisted_37 = {
  key: 0,
  class: "text-xs line-through text-light-gary-text-color"
}
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" + NT. ")
const _hoisted_39 = { class: "include-description mt-5 pt-5" }
const _hoisted_40 = { class: "px-4 flex flex-col sm:flex-row basis-full" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block mb-2.5 text-gary-text-color font-bold text-[0.937rem] sm:basis-[60px] w-[60px]" }, " 禮物包含 ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sm:basis-[43px]" }, null, -1))
const _hoisted_43 = { class: "flex-grow text-sm font-light" }
const _hoisted_44 = { class: "tracking-widest mb-1" }
const _hoisted_45 = {
  key: 0,
  class: "tracking-widest mb-1 flex justify-between"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hidden tracking-widest mb-1" }, "貼紙 x1", -1))
const _hoisted_47 = {
  key: 1,
  class: "mt-5 text-gary-text-color"
}
const _hoisted_48 = { class: "flex" }
const _hoisted_49 = { class: "ml-2" }
const _hoisted_50 = { class: "add-shopping-car mt-[16px]" }
const _hoisted_51 = { class: "px-4 flex basis-full" }
const _hoisted_52 = { class: "flex-grow" }
const _hoisted_53 = {
  key: 0,
  class: "flex flex-col grow mr-3 sm:mr-7"
}
const _hoisted_54 = { class: "w-[240px] sm:w-[300px] ml-1 sm:ml-5 mt-4 text-gary-text-color font-light text-sm" }
const _hoisted_55 = { class: "mt-2 flex justify-between" }
const _hoisted_56 = { class: "w-[240px] sm:w-[300px] ml-1 sm:ml-5 mt-4 text-gary-text-color font-light text-sm" }
const _hoisted_57 = {
  key: 1,
  class: "flex flex-col grow mr-3 sm:mr-7"
}
const _hoisted_58 = { class: "h-[50px] tracking-[.1em] rounded-lg cursor-default text-white bg-gary-text-color sm:rounded-[10px]" }
const _hoisted_59 = { class: "w-[80px] sm:w-[90px] text-right" }
const _hoisted_60 = {
  key: 0,
  class: "tracking-widest text-xs sm:text-sm line-through text-light-gary-text-color"
}
const _hoisted_61 = { class: "text-primary-color sm:text-xl font-bold" }
const _hoisted_62 = { class: "mt-10 flex flex-col space-y-3 basis-full" }
const _hoisted_63 = { class: "px-5 sm:pl-4 sm:pr-0 flex basis-full items-center" }
const _hoisted_64 = { class: "inline-block ml-[9px] text-gary-text-color font-light text-sm tracking-widest" }
const _hoisted_65 = { class: "w-[24px]" }
const _hoisted_66 = ["onClick"]
const _hoisted_67 = {
  key: 0,
  class: "add-on mt-5 pt-5"
}
const _hoisted_68 = { class: "px-4 flex basis-full items-center" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inline-block ml-[9px] text-gary-text-color font-bold text-[0.937rem]" }, " 加購 ", -1))
const _hoisted_70 = { class: "mt-4 w-full" }
const _hoisted_71 = { class: "g-collapse" }
const _hoisted_72 = { class: "flex flex-nowrap overflow-auto" }
const _hoisted_73 = { class: "text-base mt-[6px] text-gary-text-color relative cursor-pointer" }
const _hoisted_74 = { class: "text-sm" }
const _hoisted_75 = { class: "text-xs line-through text-light-gary-text-color" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" + NT. ")
const _hoisted_77 = { class: "flex justify-end gap-2" }
const _hoisted_78 = { class: "g-container mt-[60px] px-4 sm:mt-36" }
const _hoisted_79 = { class: "hidden sm:block" }
const _hoisted_80 = { class: "sm:hidden px-2.5" }
const _hoisted_81 = { class: "tab-items" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center mb-[20px] pr-[1px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color tracking-[.06em]" }, " 產品說明 ")
], -1))
const _hoisted_83 = { class: "flex flex-col mb-3 tracking-[.06em]" }
const _hoisted_84 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_85 = { class: "inline-flex" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "・", -1))
const _hoisted_87 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center pr-[1px]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "inline-block text-gary-text-color tracking-[.06em]" }, " 注意事項 ")
], -1))
const _hoisted_89 = { class: "list-none list-inside text-sm text-breadcrumb-color pt-[12px]" }
const _hoisted_90 = { class: "inline-flex" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "・", -1))
const _hoisted_92 = { class: "whitespace-pre-wrap break-all" }
const _hoisted_93 = {
  key: 1,
  itemscope: "",
  itemtype: "http://schema.org/Product"
}
const _hoisted_94 = ["content"]
const _hoisted_95 = ["content"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "description",
  content: "規格說明"
}, null, -1))
const _hoisted_97 = ["content"]
const _hoisted_98 = ["content"]
const _hoisted_99 = {
  itemprop: "offers",
  itemscope: "",
  itemtype: "http://schema.org/Offer"
}
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("link", {
  itemprop: "availability",
  href: "http://schema.org/InStock"
}, null, -1))
const _hoisted_101 = ["content"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("meta", {
  itemprop: "priceCurrency",
  content: "TWD"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spacer = _resolveComponent("Spacer")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_SwiperSquareItem = _resolveComponent("SwiperSquareItem")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_ImageRadioButton = _resolveComponent("ImageRadioButton")!
  const _component_TextRadioButton = _resolveComponent("TextRadioButton")!
  const _component_InputWithButton = _resolveComponent("InputWithButton")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_TransitionPlusButton = _resolveComponent("TransitionPlusButton")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_Collapse = _resolveComponent("Collapse")!
  const _component_Input = _resolveComponent("Input")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_AddOnModal = _resolveComponent("AddOnModal")!
  const _component_AddPortFolioModal = _resolveComponent("AddPortFolioModal")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.selectedCmdy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["hidden sm:flex g-container top-0 left-[calc(50%_-_600px)] product-info-header text-xl text-gary-text-color font-bold", [{ show: _ctx.showProductInfo }]])
          }, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.unescapeHTML(_ctx.selectedCmdy.Name)), 1),
            _createVNode(_component_Spacer),
            _createElementVNode("div", _hoisted_3, "NT. " + _toDisplayString(_ctx.selectedCmdy.MinUnitFeeReal), 1)
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["sm:hidden w-full left-[0px] top-[0px] flex justify-between product-info-header text-lg text-gary-text-color font-bold", [{ show: _ctx.showProductInfo }]])
          }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.unescapeHTML(_ctx.selectedCmdy.Name)), 1),
            _createElementVNode("div", _hoisted_5, " NT. " + _toDisplayString(_ctx.selectedCmdy.MinUnitFeeReal), 1)
          ], 2),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_Breadcrumb, {
              breadcrumbList: [
          { path: '/', title: _ctx.unescapeHTML(_ctx.selectedCmdy.Name) || '' }
        ]
            }, null, 8, ["breadcrumbList"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_SwiperSquareItem, {
                  class: "sticky top-[50px]",
                  customClass: 'g-swiper-square-item-type2',
                  selectItem: _ctx.selectedCmdy.CmdyImageList,
                  "onUpdate:selectItem": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCmdy.CmdyImageList) = $event))
                }, null, 8, ["selectItem"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.unescapeHTML(_ctx.selectedCmdy.Name)), 1),
                        _createVNode(_component_FavoriteButton, {
                          class: "cursor-pointer",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addToCollect(_ctx.selectedCmdy))),
                          isLike: _ctx.selectedCmdy.IsInCmdyCollect,
                          width: '30px'
                        }, null, 8, ["isLike"])
                      ]),
                      _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.unescapeHTML(_ctx.selectedCmdy.SubName)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specList, (spec) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: spec.CmdySpecId,
                          class: "product__options text-[15px] sm:text-base text-gary-text-color font-normal"
                        }, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, _toDisplayString(spec.Name), 1),
                            _createElementVNode("div", _hoisted_21, [
                              (spec.ShowMode === 'Thumbnail')
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(spec.CmdySpecOptionList, (optionItem) => {
                                    return (_openBlock(), _createBlock(_component_ImageRadioButton, {
                                      key: optionItem.CmdySpecId,
                                      name: optionItem.CmdySpecId,
                                      inputValue: optionItem.CmdySpecOptionId,
                                      width: "40px",
                                      text: optionItem.Name,
                                      url: optionItem.Image.PcWeb,
                                      title: optionItem.Name,
                                      modelValue: _ctx.optionModel[spec.CmdySpecId],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.optionModel[spec.CmdySpecId]) = $event),
                                      onClick: _ctx.changeOption
                                    }, null, 8, ["name", "inputValue", "text", "url", "title", "modelValue", "onUpdate:modelValue", "onClick"]))
                                  }), 128))
                                : (spec.ShowMode === 'Dropdown')
                                  ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                      key: 1,
                                      class: "border-[1px] w-fit bg-white",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.optionModel[spec.CmdySpecId]) = $event),
                                      onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changeOption && _ctx.changeOption(...args)))
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spec.CmdySpecOptionList, (optionItem) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                          key: optionItem.CmdySpecId,
                                          value: optionItem.CmdySpecOptionId
                                        }, _toDisplayString(optionItem.Name), 9, _hoisted_23))
                                      }), 128))
                                    ], 40, _hoisted_22)), [
                                      [_vModelSelect, _ctx.optionModel[spec.CmdySpecId]]
                                    ])
                                  : (spec.ShowMode === 'BoxLabel')
                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(spec.CmdySpecOptionList, (optionItem) => {
                                        return (_openBlock(), _createBlock(_component_TextRadioButton, {
                                          key: optionItem.CmdySpecId,
                                          name: optionItem.CmdySpecId,
                                          inputValue: optionItem.CmdySpecOptionId,
                                          text: optionItem.Name,
                                          modelValue: _ctx.optionModel[spec.CmdySpecId],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.optionModel[spec.CmdySpecId]) = $event),
                                          onClick: _ctx.changeOption
                                        }, null, 8, ["name", "inputValue", "text", "modelValue", "onUpdate:modelValue", "onClick"]))
                                      }), 128))
                                    : _createCommentVNode("", true)
                            ])
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", _hoisted_27, [
                            _createVNode(_component_InputWithButton, {
                              maxNumber: _ctx.selectedCmdy.MaxCmdyQty,
                              onSubtractClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.subtractClick())),
                              onAddClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addClick())),
                              modelValue: _ctx.cmdyQty,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cmdyQty) = $event))
                            }, null, 8, ["maxNumber", "modelValue"])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.selectedCmdyPackage?.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_Icon, { iconName: "package" }),
                          _hoisted_30,
                          _createVNode(_component_Spacer),
                          _createVNode(_component_TransitionPlusButton, {
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.packageShow = !_ctx.packageShow)),
                            actived: !_ctx.packageShow
                          }, null, 8, ["actived"])
                        ]),
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(_component_Collapse, null, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("div", _hoisted_32, [
                                _createVNode(_component_Swiper, {
                                  modules: _ctx.modules,
                                  autoplay: { delay: 3000 },
                                  loop: false,
                                  navigation: {
                        hiddenClass: 'swiper-button-hidden',
                        prevEl: 'g-swiper-nav-prev',
                        nextEl: 'g-swiper-nav-next'
                      }
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkArray(_ctx.selectedCmdyPackage, 3), (chunk, slideIndex) => {
                                      return (_openBlock(), _createBlock(_component_SwiperSlide, { key: slideIndex }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_33, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (cmdy) => {
                                              return (_openBlock(), _createBlock(_component_SquareItemFullImage, {
                                                key: cmdy.CmdyId,
                                                onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(cmdy, 'Package')),
                                                class: _normalizeClass(["max-w-[33.3%] p-3 border-[3px] hover:border-black-300-color rounded-lg", [
                                cmdy.Checked ? 'border-primary-color' : 'border-white'
                              ]]),
                                                customClass: ''
                                              }, {
                                                description: _withCtx(() => [
                                                  _createElementVNode("div", _hoisted_34, [
                                                    _createElementVNode("div", _hoisted_35, _toDisplayString(cmdy.Name), 1),
                                                    _createElementVNode("div", _hoisted_36, "+ NT. " + _toDisplayString(cmdy.UnitFeeReal), 1),
                                                    (cmdy.UnitFeeReal !== cmdy.UnitFeeOri)
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                          _hoisted_38,
                                                          _createElementVNode("span", null, _toDisplayString(cmdy.UnitFeeOri), 1)
                                                        ]))
                                                      : _createCommentVNode("", true),
                                                    _createVNode(_component_Icon, {
                                                      onClick: _withModifiers(($event: any) => (_ctx.setPackage(cmdy)), ["stop"]),
                                                      iconName: cmdy.Checked ? 'add_on_select' : 'circle_add',
                                                      width: '20px',
                                                      class: "cursor-pointer absolute right-0 bottom-0"
                                                    }, null, 8, ["onClick", "iconName"])
                                                  ])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick", "class"]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 2
                                      }, 1024))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modules"])
                              ], 512), [
                                [_vShow, _ctx.packageShow]
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.selectedCmdy.Name) + " x" + _toDisplayString(_ctx.cmdyQty), 1),
                        (_ctx.getSelectedPackage?.length !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                              _createTextVNode(_toDisplayString(_ctx.getSelectedPackage[0]?.Name) + " x" + _toDisplayString(_ctx.cmdyQty) + " ", 1),
                              _createElementVNode("span", null, " + NT. " + _toDisplayString(_ctx.getSelectedPackage[0]?.UnitFeeReal *
                        _ctx.getSelectedPackage[0]?.CmdyQty), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _hoisted_46,
                        (_ctx.getSelectedAddOn?.length !== 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSelectedAddOn, (AddOnCmdyItem) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: AddOnCmdyItem.CmdyId,
                                  class: "flex items-center justify-between"
                                }, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createVNode(_component_Icon, {
                                      iconName: "plus",
                                      width: "16px"
                                    }),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", null, " 加購 " + _toDisplayString(AddOnCmdyItem.Name) + " x" + _toDisplayString(AddOnCmdyItem.CmdyQty), 1)
                                    ])
                                  ]),
                                  _createElementVNode("div", null, " + NT. " + _toDisplayString(AddOnCmdyItem.UnitFeeReal * AddOnCmdyItem.CmdyQty), 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      (_ctx.selectedCmdy.Status === 'OutOfStock')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _createElementVNode("button", {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sentRestockNotification(_ctx.selectedCmdy.CmdyId))),
                              class: "h-[50px] tracking-[.1em] rounded-lg cursor-pointer text-white bg-gary-text-color sm:rounded-[10px]"
                            }, " 到貨通知我 "),
                            _withDirectives(_createElementVNode("span", _hoisted_54, "當商品重新上架可購買時，您將立即收到電子郵件通知", 512), [
                              [_vShow, _ctx.mailShow === 1]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_55, [
                              true
                                ? (_openBlock(), _createBlock(_component_Input, {
                                    key: 0,
                                    class: "grow mr-2 text-xs",
                                    width: '100%',
                                    height: '50px',
                                    placeholder: '請輸入Email',
                                    modelValue: _ctx.restockMail,
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.restockMail) = $event))
                                  }, null, 8, ["modelValue"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sentRestockNotification(_ctx.selectedCmdy.CmdyId))),
                                class: "h-[50px] w-[50px] sm:w-[80px] tracking-[.1em] rounded-lg text-white bg-gary-text-color sm:rounded-[10px] hover:bg-primary-color active:bg-primary-color"
                              }, " 發送 ")
                            ], 512), [
                              [_vShow, _ctx.mailShow === 2]
                            ]),
                            _withDirectives(_createElementVNode("span", _hoisted_56, "謝謝您！當商品重新上架可購買時，您將立即收到電子郵件通知", 512), [
                              [_vShow, _ctx.mailShow === 3]
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedCmdy.Status === 'ToBeActived' || _ctx.selectedCmdy.Status === 'SoldOut' || _ctx.selectedCmdy.Status === 'Inactive')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("button", _hoisted_58, _toDisplayString(_ctx.selectedCmdy.Status === 'SoldOut' || _ctx.selectedCmdy.Status === 'Inactive' ? '售完' : '即將開賣'), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (
                    _ctx.selectedCmdy.Status === 'Active' &&
                    _ctx.selectedCmdy.IsEndProduct === 1
                  )
                        ? (_openBlock(), _createBlock(_component_Btn, {
                            key: 2,
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addShoppingCart(_ctx.selectedCmdy))),
                            text: '加入購物車',
                            width: '100%',
                            height: '50px'
                          }))
                        : _createCommentVNode("", true),
                      (
                    _ctx.selectedCmdy.Status === 'Active' &&
                    _ctx.selectedCmdy.IsEndProduct === 0
                  )
                        ? (_openBlock(), _createBlock(_component_Btn, {
                            key: 3,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (
                    _ctx.clickGoEditor()
                  )),
                            text: '開始訂製',
                            width: '100%',
                            height: '50px'
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_59, [
                      (
                    _ctx.getSelectPrice.TotalOriAmt !== _ctx.getSelectPrice.TotalRealAmt
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_60, " NT. " + _toDisplayString(_ctx.getSelectPrice.TotalOriAmt), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_61, " NT. " + _toDisplayString(_ctx.getSelectPrice.TotalRealAmt), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_Icon, { iconName: "cart" }),
                      _createElementVNode("div", _hoisted_64, " 今天訂購 約 " + _toDisplayString(_ctx.selectedCmdy.MinPreparationDays) + "-" + _toDisplayString(_ctx.selectedCmdy.MaxPreparationDays) + "天 到貨，不含假日及國定假期 ", 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedCmdy.PromotionList, (promotionItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: promotionItem.PromotionActivityId,
                        class: "px-5 sm:pl-4 sm:pr-0 flex basis-full"
                      }, [
                        _createElementVNode("div", _hoisted_65, [
                          _createVNode(_component_Icon, { iconName: "giveaway_big" })
                        ]),
                        _createElementVNode("div", {
                          class: "ml-[9px] text-primary-color font-light text-sm tracking-widest cursor-pointer",
                          onClick: (e) => {e.preventDefault(); e.stopPropagation(); _ctx.EventBus.emit('openActivityModal', promotionItem.PromotionActivityId); }
                        }, _toDisplayString(promotionItem.PromotionActivityName), 9, _hoisted_66)
                      ]))
                    }), 128))
                  ])
                ]),
                (_ctx.selectedCmdyAddOn?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_Icon, { iconName: "add_on" }),
                        _hoisted_69,
                        _createVNode(_component_Spacer),
                        _createVNode(_component_TransitionPlusButton, {
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.addOnShow = !_ctx.addOnShow)),
                          actived: !_ctx.addOnShow
                        }, null, 8, ["actived"])
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_Collapse, null, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("div", _hoisted_71, [
                              _createVNode(_component_Swiper, {
                                modules: _ctx.modules,
                                autoplay: { delay: 3000 },
                                loop: false,
                                navigation: {
                      hiddenClass: 'swiper-button-hidden',
                      prevEl: 'g-swiper-nav-prev',
                      nextEl: 'g-swiper-nav-next'
                    }
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chunkArray(_ctx.selectedCmdyAddOn, 3), (chunk, slideIndex) => {
                                    return (_openBlock(), _createBlock(_component_SwiperSlide, { key: slideIndex }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_72, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chunk, (cmdy) => {
                                            return (_openBlock(), _createBlock(_component_SquareItemFullImage, {
                                              key: cmdy.CmdyId,
                                              onClick: ($event: any) => (_ctx.setSelectAddOnCmdy(cmdy, 'AddOn')),
                                              image: cmdy.Image.PcWeb,
                                              class: "max-w-[43%] sm:max-w-[33%] px-4",
                                              customClass: ''
                                            }, {
                                              description: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_73, [
                                                  _createElementVNode("div", null, _toDisplayString(cmdy.Name), 1),
                                                  _createElementVNode("div", _hoisted_74, "+ NT. " + _toDisplayString(cmdy.UnitFeeReal), 1),
                                                  _createElementVNode("div", _hoisted_75, [
                                                    _hoisted_76,
                                                    _createElementVNode("span", null, _toDisplayString(cmdy.UnitFeeOri), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_77, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(['cursor-pointer', cmdy.Checked ? 'num-icon' : ''])
                                                    }, [
                                                      (cmdy.Checked)
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            _createTextVNode(_toDisplayString(cmdy.CmdyQty), 1)
                                                          ], 64))
                                                        : (_openBlock(), _createBlock(_component_Icon, {
                                                            key: 1,
                                                            iconName: "circle_add"
                                                          }))
                                                    ], 2),
                                                    (cmdy.Checked)
                                                      ? (_openBlock(), _createBlock(_component_Icon, {
                                                          key: 0,
                                                          iconName: "trash-regular",
                                                          class: "cursor-pointer",
                                                          width: "24px",
                                                          onClick: _withModifiers(($event: any) => (_ctx.removeAddOn(cmdy.CmdyId)), ["stop"])
                                                        }, null, 8, ["onClick"]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ])
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick", "image"]))
                                          }), 128))
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modules"])
                            ], 512), [
                              [_vShow, _ctx.addOnShow]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createVNode(_component_Tabs, {
                  data: [{ id: 2, text: '規格說明' }],
                  customClass: 'custom-product-tabs',
                  onTabSelect: _ctx.tabSelect
                }, null, 8, ["onTabSelect"]),
                _createVNode(_component_Divider, { class: "mb-8 mx-4 sm:mx-0" })
              ]),
              _createElementVNode("div", _hoisted_80, [
                _createVNode(_component_Tabs, {
                  data: [{ id: 2, text: '規格說明' }],
                  customClass: 'mobile-custom-product-tabs',
                  onMobileTabSelect: _ctx.mobileTabSelect
                }, null, 8, ["onMobileTabSelect"])
              ]),
              _createElementVNode("div", _hoisted_81, [
                (_ctx.selectedCmdy.SpecDesc)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["tab-item-block px-4 sm:px-[69px]", [{ actived: _ctx.tab === 0 }]])
                    }, [
                      _hoisted_82,
                      _createElementVNode("div", _hoisted_83, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectedCmdy.SpecDesc)
                  .ProductDesc.DescList, (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "text-sm text-breadcrumb-color",
                            key: index
                          }, _toDisplayString(item.Spec), 1))
                        }), 128)),
                        _createElementVNode("ul", _hoisted_84, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectedCmdy.SpecDesc)
                    .ProductDesc?.SpecList, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _createElementVNode("div", _hoisted_85, [
                                _hoisted_86,
                                _createElementVNode("span", _hoisted_87, _toDisplayString(item.Spec), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ]),
                      _hoisted_88,
                      _createElementVNode("div", null, [
                        _createElementVNode("ul", _hoisted_89, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(JSON.parse(_ctx.selectedCmdy.SpecDesc)
                    .WarningList?.SpecList, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _createElementVNode("div", _hoisted_90, [
                                _hoisted_91,
                                _createElementVNode("span", _hoisted_92, _toDisplayString(item.Warning), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode(_component_AddOnModal, {
              show: _ctx.showAddOnModal,
              cmdyType: _ctx.selectedType,
              AddOnCmdyItem: _ctx.selectAddOnCmdy,
              MainCmdyId: _ctx.selectedCmdy.CmdyId,
              setPackage: _ctx.setPackage,
              onOk: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showAddOnModal = false)),
              onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showAddOnModal = false)),
              "onUpdate:AddOnCmdyItem": _ctx.updateCmdyAddOn
            }, null, 8, ["show", "cmdyType", "AddOnCmdyItem", "MainCmdyId", "setPackage", "onUpdate:AddOnCmdyItem"])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.selectedCmdy)
      ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
          _createElementVNode("meta", {
            itemprop: "name",
            content: _ctx.selectedCmdy.Name
          }, null, 8, _hoisted_94),
          _createElementVNode("meta", {
            itemprop: "productID",
            content: _ctx.selectedCmdy.CmdyId
          }, null, 8, _hoisted_95),
          _hoisted_96,
          _createElementVNode("meta", {
            itemprop: "url",
            content: _ctx.currentUrl
          }, null, 8, _hoisted_97),
          (_ctx.selectedCmdy.CmdyImageList)
            ? (_openBlock(), _createElementBlock("meta", {
                key: 0,
                itemprop: "image",
                content: _ctx.selectedCmdy.CmdyImageList[0].Image.PcWeb
              }, null, 8, _hoisted_98))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_99, [
            _hoisted_100,
            _createElementVNode("meta", {
              itemprop: "price",
              content: _ctx.selectedCmdy.MinUnitFeeReal
            }, null, 8, _hoisted_101),
            _hoisted_102
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AddPortFolioModal, {
      modelValue: _ctx.portfolioName,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.portfolioName) = $event)),
      ref: "addPortFolioModal"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_ModalConfirm, { ref: "confirmModal" }, null, 512)
  ], 64))
}